/* dwl-smart-search.js — slimme zoekfunctie (nov 2026)
 *
 * Vervangt het oude dwl-suggest-paneel (zat in dwl-head-bundle.js).
 * - Eigen zoekindex: /collections/all?view=dwl-index (titel, prijs, foto,
 *   AI-zoekwoorden in 5 talen uit custom.search_terms, passende eenden uit custom.pairs).
 * - Begrijpt NL/EN/DE/FR/ES, kleine typfouten, en rangschikt slim:
 *   naam > zoekwoorden > favorieten; uitverkocht, gratis cadeaus en
 *   seizoensthema's (voetbal/WK) zakken, tenzij je er echt naar zoekt.
 * - Leeg zoekvak: persoonlijke suggesties (past bij je winkelwagen /
 *   wat je net bekeek / onze favorieten).
 * - /search: slimme resultaten bovenaan, Shopify-resultaten als terugval.
 * Collecties en pagina's komen nog uit Shopify's eigen suggesties.
 * Nov 2026: laadt async dwl-brain-data.js + dwl-brain.js (het 'brein'): zoeken op thema/reeks in
 * 5 talen ("voetbal", "Hochzeit", "verpleegkundige", "tovenaar"), nooit meer een lege pagina,
 * interesse onthouden (dwl_affinity), persoonlijke suggesties. Zonder brein werkt alles als voorheen.
 */
(function () {
  'use strict';
  if (window.__dwlSmartSearch) return;
  window.__dwlSmartSearch = true;

  /* ---------- Teksten ---------- */
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var L = {
    nl: { add: 'In winkelwagen', added: 'Toegevoegd', soldOut: 'Uitverkocht', view: 'Bekijken', choose: 'Kies optie', seeAll: 'Alle resultaten voor', noResults: 'Geen resultaten voor', collections: 'Collecties', products: 'Eendjes', pages: "Pagina's", labelColl: 'Collectie', labelPage: 'Pagina', forCart: 'Past bij je winkelwagen', forViewed: 'Past bij wat je bekeek', favourites: 'Onze favorieten', placeholder: 'Zoek eendjes…', best: 'Beste resultaten voor', tip: 'Mix & match: 3 eenden −10%, 5 of meer −15%.' },
    de: { add: 'In den Warenkorb', added: 'Hinzugefügt', soldOut: 'Ausverkauft', view: 'Ansehen', choose: 'Option wählen', seeAll: 'Alle Ergebnisse für', noResults: 'Keine Ergebnisse für', collections: 'Kollektionen', products: 'Enten', pages: 'Seiten', labelColl: 'Kollektion', labelPage: 'Seite', forCart: 'Passt zu deinem Warenkorb', forViewed: 'Passt zu dem, was du angesehen hast', favourites: 'Unsere Favoriten', placeholder: 'Enten suchen…', best: 'Beste Ergebnisse für', tip: 'Mix & Match: 3 Enten −10 %, ab 5 −15 %.' },
    fr: { add: 'Ajouter au panier', added: 'Ajouté', soldOut: 'Épuisé', view: 'Voir', choose: 'Choisir une option', seeAll: 'Tous les résultats pour', noResults: 'Aucun résultat pour', collections: 'Collections', products: 'Canards', pages: 'Pages', labelColl: 'Collection', labelPage: 'Page', forCart: 'Va bien avec votre panier', forViewed: 'Va bien avec ce que vous avez vu', favourites: 'Nos favoris', placeholder: 'Chercher des canards…', best: 'Meilleurs résultats pour', tip: 'Mix & match : 3 canards −10 %, 5 ou plus −15 %.' },
    es: { add: 'Añadir a la cesta', added: 'Añadido', soldOut: 'Agotado', view: 'Ver', choose: 'Elegir opción', seeAll: 'Todos los resultados de', noResults: 'Sin resultados para', collections: 'Colecciones', products: 'Patos', pages: 'Páginas', labelColl: 'Colección', labelPage: 'Página', forCart: 'Combina con tu cesta', forViewed: 'Combina con lo que has visto', favourites: 'Nuestros favoritos', placeholder: 'Buscar patos…', best: 'Mejores resultados para', tip: 'Mix & match: 3 patos −10 %, 5 o más −15 %.' },
    en: { add: 'Add to cart', added: 'Added', soldOut: 'Sold out', view: 'View', choose: 'Choose options', seeAll: 'See all results for', noResults: 'No results for', collections: 'Collections', products: 'Ducks', pages: 'Pages', labelColl: 'Collection', labelPage: 'Page', forCart: 'Goes well with your cart', forViewed: 'Goes well with what you viewed', favourites: 'Our favourites', placeholder: 'Search ducks…', best: 'Best results for', tip: 'Mix & match: 3 ducks −10%, 5 or more −15%.' }
  };
  var T = L[LANG] || L.en;

  var NEEDS_OPTIONS = ['signducks'];
  var SEASON = /\b(football|voetbal|fussball|fußball|soccer|futbol|fútbol|world ?cup|wk|ek)\b/;
  var MIN_CHARS = 2, DEBOUNCE = 160, LIMIT_PROD = 6, LIMIT_COLL = 3, LIMIT_PAGE = 2, LIMIT_PAGE_RESULTS = 48;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(cents) {
    if (cents == null || cents === '') return '';
    return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function store(kind, key, val) {
    try {
      var s = kind === 'local' ? window.localStorage : window.sessionStorage;
      if (val === undefined) return s.getItem(key);
      s.setItem(key, val);
    } catch (e) { return null; }
  }

  /* ---------- Brein bijladen (async, na deze file; zelfde map en versie) ---------- */
  var BR = null;
  var brainReady = new Promise(function (res) {
    if (window.DWLBrain) { BR = window.DWLBrain; res(BR); return; }
    var src = document.currentScript && document.currentScript.src;
    if (!src) { res(null); return; }
    var base = src.split('?')[0].replace(/dwl-smart-search\.js$/, ''), q = src.split('?')[1] || '', left = 2;
    var done = function () { if (--left === 0) { BR = window.DWLBrain || null; res(BR); } };
    ['dwl-brain-data.js', 'dwl-brain.js'].forEach(function (f) {
      var el = document.createElement('script');
      el.src = base + f + '?' + (q ? q + '&' : '') + 'b=kb2';
      el.async = false;
      el.onload = done; el.onerror = done;
      document.head.appendChild(el);
    });
    setTimeout(function () { if (left > 0) { left = 1; done(); } }, 8000);
  });

  /* ---------- Placeholder in de juiste taal ---------- */
  function setPlaceholders() {
    var f = document.querySelectorAll('input[type="search"][name="q"]');
    for (var i = 0; i < f.length; i++) if (f[i].placeholder !== T.placeholder) f[i].placeholder = T.placeholder;
  }

  /* ---------- Laatst bekeken product onthouden ---------- */
  (function trackViewed() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var list = [];
    try { list = JSON.parse(store('local', 'dwl_viewed') || '[]'); } catch (e) {}
    list = [m[1]].concat(list.filter(function (h) { return h !== m[1]; })).slice(0, 6);
    store('local', 'dwl_viewed', JSON.stringify(list));
  })();

  /* ---------- Index ---------- */
  var INDEX = null, BY = {}, loading = null;
  var CACHE_KEY = 'dwl_idx_v3_' + LANG;
  function prep(items) {
    INDEX = items.map(function (p) {
      var hay = norm(p.t) ;
      p._t = hay;
      p._tw = hay.split(' ');
      p._k = ' ' + norm(p.k + ' ' + p.g + ' ' + p.y) + ' ';
      p._kw = p._k.trim().split(' ');
      p._season = SEASON.test(' ' + norm(p.t + ' ' + p.g) + ' ');
      p._gift = !p.p || / gift /.test(' ' + norm(p.h.replace(/-/g, ' ')) + ' ') || !!(BR && BR.isGift(p));
      p._set = /complete set/.test(norm(p.t));
      p._r = (p.r || '').split(',').filter(Boolean);
      BY[p.h] = p;
      return p;
    });
    return INDEX;
  }
  /* index via het brein (gedeeld, met productkennis); zonder brein zelf ophalen zoals voorheen */
  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    return brainReady.then(function (B) {
      return B ? B.index().then(function (items) { return items ? prep(items) : loadIndex0(); }) : loadIndex0();
    });
  }
  function loadIndex0() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    var cached = store('session', CACHE_KEY);
    if (cached) { try { return Promise.resolve(prep(JSON.parse(cached))); } catch (e) {} }
    var url = function (n) { return root() + '/collections/all?view=dwl-index&page=' + n; };
    loading = fetch(url(1)).then(function (r) { return r.json(); }).then(function (first) {
      var items = first.items || [];
      var rest = [];
      for (var n = 2; n <= (first.pages || 1); n++) rest.push(fetch(url(n)).then(function (r) { return r.json(); }));
      return Promise.all(rest).then(function (pages) {
        pages.forEach(function (pg) { items = items.concat(pg.items || []); });
        store('session', CACHE_KEY, JSON.stringify(items));
        return prep(items);
      });
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  /* ---------- Zoeken ---------- */
  function lev1(a, b) { // true als a en b maximaal 1 bewerking verschillen
    if (a === b) return true;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, diff = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++diff > 1) return false;
      if (la > lb) i++; else if (lb > la) j++; else { i++; j++; }
    }
    return diff + (la - i) + (lb - j) <= 1;
  }
  function tokenScore(tok, p) {
    var best = 0, i, w;
    for (i = 0; i < p._tw.length; i++) {
      w = p._tw[i];
      if (w === tok) return 12;
      if (w.indexOf(tok) === 0) best = Math.max(best, tok.length >= 3 ? 9 : 5);
    }
    if (p._t.indexOf(tok) !== -1 && tok.length >= 3) best = Math.max(best, 6);
    if (best >= 9) return best;
    if (p._k.indexOf(' ' + tok + ' ') !== -1) best = Math.max(best, 8);
    else {
      for (i = 0; i < p._kw.length; i++) {
        w = p._kw[i];
        if (w.indexOf(tok) === 0) { best = Math.max(best, tok.length >= 3 ? 6 : 2); break; }
      }
    }
    if (!best && tok.length >= 4) {
      var pool = p._tw.concat(p._kw);
      for (i = 0; i < pool.length; i++) {
        if (pool[i].length >= 4 && lev1(tok, pool[i])) { best = 3; break; }
      }
    }
    return best;
  }
  function search(term, limit) {
    if (!INDEX) return [];
    var q = norm(term);
    if (!q) return [];
    var toks0 = q.split(' ').filter(function (t) { return t.length > 1 || /\d/.test(t); });
    var toks = BR ? toks0.filter(function (t) { return !BR.STOP[t]; }) : toks0;
    if (!toks.length) toks = toks0;
    if (!toks.length) return [];
    var wantSeason = SEASON.test(' ' + q + ' ');
    var I = BR ? BR.intent(q) : { keys: [], alias: [], fav: false }, keys = I.keys;
    var wantSmall = keys.indexOf('s:minis') > -1 || /keychain|sleutelhanger|schlusselanhanger|porte cles|llavero|tas|tasje|bag|tasche|sac|bolso|bobblehead|deurstopper|doorstop/.test(q);
    var out = [];
    for (var i = 0; i < INDEX.length; i++) {
      var p = INDEX[i];
      if (p._gift) continue;
      var sum = 0, hit = 0;
      for (var j = 0; j < toks.length; j++) {
        var s = tokenScore(toks[j], p);
        if (s) { hit++; sum += s; }
      }
      var ks = 0, al = 0;
      if (keys.length) { var pk = BR.keysOf(p); keys.forEach(function (k) { if (pk.indexOf(k) > -1) ks += (k.charAt(0) === 's' ? 2 : 1); }); }
      I.alias.forEach(function (a) { al = Math.max(al, tokenScore(a, p)); });
      var favHit = I.fav && p.f;
      if (!hit && !ks && !al && !favHit) continue;
      var score = hit ? sum / toks.length + (hit === toks.length ? 6 : 0) : 0;
      if (al) score = Math.max(score, al + 6);
      if (ks) score = hit ? score + 4 * ks : Math.max(score, 8 + 2 * ks);
      if (favHit && !hit && !ks) score = Math.max(score, 9);
      /* mini's en accessoires nooit vóór gewone eenden (tenzij je ernaar zoekt) */
      if (BR && !wantSmall && (BR.isAccessory(p) || BR.isMini(p))) score -= (hit || al ? 2 : 6);
      if (p._t === q) score += 20;
      else if (p._t.indexOf(q) === 0) score += 8;
      if (p.f) score += 2.5;
      if (p._set) score += 1;
      if (!p.a) score -= 12;
      /* seizoenseenden zakken, behalve als je ze bij naam zoekt (bv. 'Johan') */
      if (p._season && !wantSeason && !al && !(hit === toks.length && p._t.indexOf(q) !== -1)) score -= 10;
      out.push({ p: p, s: score });
    }
    out.sort(function (a, b) { return b.s - a.s || a.p.t.localeCompare(b.p.t); });
    // Alleen zwakke treffers? Dan liever minder tonen.
    if (out.length && out[0].s >= 14) out = out.filter(function (o) { return o.s >= 8; });
    return out.slice(0, limit || LIMIT_PROD).map(function (o) { return o.p; });
  }

  /* ---------- Persoonlijke suggesties (leeg zoekvak) ---------- */
  function shuffleDaily(arr) {
    var seed = Number(store('session', 'dwl_seed')) || Math.floor(Math.random() * 1e6);
    store('session', 'dwl_seed', String(seed));
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      seed = (seed * 9301 + 49297) % 233280;
      var j = Math.floor(seed / 233280 * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function pairsOf(handles, exclude) {
    var seen = {}, out = [];
    (exclude || []).forEach(function (h) { seen[h] = 1; });
    handles.forEach(function (h) { seen[h] = 1; });
    for (var round = 0; round < 4; round++) {
      handles.forEach(function (h) {
        var p = BY[h]; if (!p) return;
        var r = p._r[round];
        var q = r && BY[r];
        if (q && !seen[q.h] && q.a && !q._gift && !q._season) { seen[q.h] = 1; out.push(q); }
      });
    }
    if (!BR) return out;
    /* gewone eenden eerst, dan mini's, dan accessoires */
    var tier = function (p) { return BR.isAccessory(p) ? 2 : (BR.isMini(p) ? 1 : 0); };
    return out.map(function (p, i) { return [p, i]; }).sort(function (a, b) { return tier(a[0]) - tier(b[0]) || a[1] - b[1]; }).map(function (x) { return x[0]; });
  }
  function suggestionsFor() {
    return fetch(root() + '/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = (cart.items || []).filter(function (l) { return !(l.properties && l.properties._gift) && l.final_line_price > 0; })
          .map(function (l) { return l.handle; });
        var list = [], title = T.favourites;
        if (inCart.length) { list = pairsOf(inCart.slice(-3), inCart); title = T.forCart; }
        if (list.length < 3 && BR && BR.top(1).length) {
          var ex = {}; inCart.forEach(function (h) { ex[h] = 1; });
          var y = BR.forYou(LIMIT_PROD, ex);
          if (y.title !== T.favourites && y.items.length >= 3) { list = y.items; title = y.title; }
        }
        if (list.length < 3) {
          var viewed = [];
          try { viewed = JSON.parse(store('local', 'dwl_viewed') || '[]'); } catch (e) {}
          if (viewed.length) {
            var v = pairsOf(viewed.slice(0, 2), inCart);
            if (v.length >= 3) { list = v; title = T.forViewed; }
          }
        }
        if (list.length < 3) {
          list = shuffleDaily(INDEX.filter(function (p) { return p.f && p.a && !p._gift && !p._season && inCart.indexOf(p.h) === -1; }));
          title = T.favourites;
        }
        return { title: title, items: list.slice(0, LIMIT_PROD) };
      });
  }

  /* ---------- Toevoegen aan winkelwagen ---------- */
  function refreshCart() {
    try { if (window.DWLCart && typeof window.DWLCart.refreshCartUI === 'function') window.DWLCart.refreshCartUI(); } catch (e) {}
    fetch(root() + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var els = document.querySelectorAll('.cart-count');
      for (var i = 0; i < els.length; i++) els[i].textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
    }).catch(function () {});
  }
  function flash(btn, text, cls) {
    var original = btn.dataset.label || btn.innerHTML;
    btn.dataset.label = original;
    btn.classList.add(cls);
    btn.innerHTML = text;
    setTimeout(function () { btn.classList.remove(cls); btn.innerHTML = original; btn.disabled = false; }, 1600);
  }
  function postToCart(btn, variantId) {
    btn.disabled = true; btn.classList.add('is-busy');
    fetch(root() + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _upsell: 'search' } }] })
    }).then(function (res) {
      btn.classList.remove('is-busy');
      if (!res.ok) throw new Error('failed');
      refreshCart(); flash(btn, T.added, 'is-done');
    }).catch(function () { btn.classList.remove('is-busy'); flash(btn, T.view, 'is-error'); });
  }
  function showVariants(item, variants, btn) {
    var box = item.querySelector('.dwl-suggest__variants');
    if (box) { box.remove(); return; }
    box = document.createElement('div');
    box.className = 'dwl-suggest__variants';
    box.innerHTML = variants.map(function (v) {
      return '<button type="button" class="dwl-suggest__variant" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
    }).join('');
    item.appendChild(box);
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('.dwl-suggest__variant');
      if (!chip || chip.disabled) return;
      e.preventDefault(); e.stopPropagation();
      box.querySelectorAll('.dwl-suggest__variant').forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');
      btn.dataset.variant = chip.getAttribute('data-variant');
      btn.dataset.label = T.add; btn.innerHTML = T.add; btn.disabled = false;
    });
  }
  function addToCart(btn) {
    var url = btn.getAttribute('data-url');
    if (btn.dataset.needsOptions === '1') { window.location.href = url; return; }
    if (btn.dataset.variant && btn.dataset.multi !== '1') { postToCart(btn, parseInt(btn.dataset.variant, 10)); return; }
    var handle = (url.match(/\/products\/([^?#/]+)/) || [])[1];
    if (!handle) { window.location.href = url; return; }
    var item = btn.closest('.dwl-suggest__item, .dss-card');
    btn.disabled = true; btn.classList.add('is-busy');
    fetch(root() + '/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      btn.classList.remove('is-busy'); btn.disabled = false;
      var vs = (p && p.variants) || [];
      var ok = vs.filter(function (v) { return v.available; });
      if (!ok.length) { flash(btn, T.soldOut, 'is-error'); return; }
      if (vs.length > 1) { btn.dataset.multi = '0'; btn.dataset.label = T.choose; btn.innerHTML = T.choose; showVariants(item, vs, btn); return; }
      postToCart(btn, ok[0].id);
    }).catch(function () { btn.classList.remove('is-busy'); btn.disabled = false; window.location.href = url; });
  }

  /* ---------- Weergave paneel ---------- */
  function needsOptions(h) { return NEEDS_OPTIONS.indexOf(String(h).toLowerCase()) !== -1; }
  function productRow(p) {
    var opts = needsOptions(p.h);
    var label = !p.a ? T.soldOut : (opts || p.m ? T.choose : T.add);
    var price = p.c > p.p ? '<s>' + money(p.c) + '</s> ' + money(p.p) : money(p.p);
    return '<li class="dwl-suggest__item"><a class="dwl-suggest__link" href="' + esc(p.u) + '">' +
      (p.i ? '<img class="dwl-suggest__img" src="' + esc(p.i) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="dwl-suggest__img"></span>') +
      '<span class="dwl-suggest__text"><span class="dwl-suggest__title">' + esc(p.t) + '</span><span class="dwl-suggest__price">' + price + '</span></span></a>' +
      '<button type="button" class="dwl-suggest__add' + (opts ? ' is-options' : '') + '" data-url="' + esc(p.u) + '" data-variant="' + p.v + '"' +
      (p.m ? ' data-multi="1"' : '') + (opts ? ' data-needs-options="1"' : '') + (p.a ? '' : ' disabled') + '>' + label + '</button></li>';
  }
  function linkRow(item, label) {
    var img = item.image && (item.image.url || item.image.src || item.image);
    if (typeof img !== 'string') img = '';
    return '<li class="dwl-suggest__item dwl-suggest__item--link"><a class="dwl-suggest__link" href="' + esc(item.url) + '">' +
      (img ? '<img class="dwl-suggest__img" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
      '<span class="dwl-suggest__text"><span class="dwl-suggest__title">' + esc(item.title) + '</span></span><span class="dwl-suggest__tag">' + label + '</span></a></li>';
  }
  function group(title, rows) { return rows ? '<p class="dwl-suggest__heading">' + esc(title) + '</p><ul class="dwl-suggest__list">' + rows + '</ul>' : ''; }
  function searchUrl(term) { return root() + '/search?q=' + encodeURIComponent(term) + '&type=product,page,article&options[prefix]=last'; }

  function panelFor(field) {
    var form = field.form || field.closest('form');
    if (!form) return null;
    var panel = form.parentElement && form.parentElement.querySelector('.dwl-suggest');
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'dwl-suggest';
    panel.hidden = true;
    form.insertAdjacentElement('afterend', panel);
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('.dwl-suggest__add');
      if (btn) { e.preventDefault(); e.stopPropagation(); addToCart(btn); }
    });
    return panel;
  }

  function renderResults(panel, term, prods, shop) {
    var colls = (shop && shop.collections) || [];
    var pages = ((shop && shop.pages) || []).concat((shop && shop.articles) || []);
    if (!prods.length && !colls.length && !pages.length) {
      /* niets gevonden: persoonlijk bericht + eendjes die bij je passen */
      var y = BR ? BR.forYou(4) : { items: [] };
      panel.innerHTML = '<p class="dwl-suggest__empty">' + esc(y.items.length ? BR.C.zero.replace('[q]', term) : T.noResults + ' “' + term + '”') + '</p>' +
        (y.items.length ? group(y.title, y.items.map(productRow).join('')) : '');
      panel.hidden = false; return;
    }
    var html = '';
    if (prods.length) html += group(T.products, prods.map(productRow).join(''));
    if (colls.length) html += group(T.collections, colls.slice(0, LIMIT_COLL).map(function (c) { return linkRow(c, T.labelColl); }).join(''));
    if (pages.length) html += group(T.pages, pages.slice(0, LIMIT_PAGE).map(function (p) { return linkRow(p, T.labelPage); }).join(''));
    html += '<a class="dwl-suggest__all" href="' + searchUrl(term) + '">' + T.seeAll + ' “' + esc(term) + '”</a>';
    panel.innerHTML = html; panel.hidden = false;
  }

  function wire(field) {
    if (field.dataset.dwlSuggest === '1') return;
    field.dataset.dwlSuggest = '1';
    field.setAttribute('autocomplete', 'off');
    var timer = null, controller = null, closedAt = 0;
    function hide() {
      closedAt = Date.now(); clearTimeout(timer);
      if (controller) try { controller.abort(); } catch (e) {}
      var p = panelFor(field); if (p) { p.hidden = true; p.innerHTML = ''; }
    }
    function lookup(fromFocus) {
      var term = field.value.trim();
      var panel = panelFor(field);
      if (!panel) return;
      if (term.length < MIN_CHARS) {
        if (!fromFocus) { hide(); return; }
        if (Date.now() - closedAt < 500) return;
        loadIndex().then(function (idx) {
          if (!idx || field.value.trim().length >= MIN_CHARS) return;
          return suggestionsFor().then(function (s) {
            if (field.value.trim().length >= MIN_CHARS || !s.items.length) return;
            panel.innerHTML = group(s.title, s.items.map(productRow).join('')) + '<p class="dwl-suggest__tip">' + esc(T.tip) + '</p>';
            panel.hidden = false;
          });
        });
        return;
      }
      if (controller) try { controller.abort(); } catch (e) {}
      controller = window.AbortController ? new AbortController() : null;
      var shopReq = fetch(root() + '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=collection,page,article,product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][prefix]=last',
        controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d && d.resources && d.resources.results) || {}; })
        .catch(function () { return {}; });
      Promise.all([loadIndex(), shopReq]).then(function (res) {
        if (field.value.trim() !== term) return;
        var shop = res[1];
        var prods = res[0] ? search(term, LIMIT_PROD) : [];
        if (!prods.length && shop.products) {
          // Terugval: Shopify's producten (bv. een product dat net nieuw is)
          prods = shop.products.slice(0, LIMIT_PROD).map(function (sp) {
            var h = (sp.url.match(/\/products\/([^?#/]+)/) || [])[1];
            if (h && BY[h]) return BY[h];
            return { h: h || '', t: sp.title, u: sp.url, p: Math.round(parseFloat(sp.price || 0) * 100), c: 0, i: (sp.image || ''), v: 0, a: sp.available !== false ? 1 : 0, m: 1 };
          });
        }
        renderResults(panel, term, prods, shop);
        if (BR && term.length >= 3) BR.recordSearch(term);
      });
    }
    field.addEventListener('input', function () {
      if (field.value.trim().length) closedAt = 0;
      clearTimeout(timer);
      timer = setTimeout(function () { lookup(false); }, DEBOUNCE);
    });
    field.addEventListener('focus', function () { lookup(true); });
    field.addEventListener('search', function () { if (!field.value.trim()) hide(); });
    field.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    document.addEventListener('click', function (e) {
      var panel = panelFor(field);
      if (!panel || panel.hidden || e.target === field || panel.contains(e.target)) return;
      hide();
    });
    document.addEventListener('dwl:suggest-close', hide);
  }

  /* ---------- /search: slimme resultaten bovenaan ---------- */
  function searchPage() {
    var box = document.getElementById('dwl-smart-results');
    if (!box) return;
    var term = box.getAttribute('data-q') || '';
    if (norm(term).length < MIN_CHARS) return;
    loadIndex().then(function (idx) {
      if (!idx) return;
      if (BR) BR.recordSearch(term);
      var prods = search(term, LIMIT_PAGE_RESULTS), zero = !prods.length, head;
      if (zero) {
        /* niets gevonden: nooit een lege pagina — persoonlijk bericht + eendjes die bij je passen */
        var y = BR ? BR.forYou(8) : { items: [] };
        if (!y.items.length) return;
        prods = y.items;
        head = '<p class="dss-head">' + esc(BR.C.zero.replace('[q]', term)) + '</p><p class="dss-tip">' + esc(y.title) + ' · ' + esc(T.tip) + '</p>';
      } else head = '<p class="dss-head">' + esc(T.best) + ' “' + esc(term) + '”</p><p class="dss-tip">' + esc(T.tip) + '</p>';
      box.innerHTML = head + '<ul class="dss-grid">' +
        prods.map(function (p) {
          var opts = needsOptions(p.h);
          var label = !p.a ? T.soldOut : (opts || p.m ? T.choose : T.add);
          var price = p.c > p.p ? '<s>' + money(p.c) + '</s> ' + money(p.p) : money(p.p);
          return '<li class="dss-card"><a class="dss-card__media" href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i.replace('width=200', 'width=400')) + '" alt="' + esc(p.t) + '" loading="lazy" width="200" height="200">' : '') + '</a>' +
            '<a class="dss-card__name" href="' + esc(p.u) + '">' + esc(p.t) + '</a><span class="dss-card__price">' + price + '</span>' +
            '<button type="button" class="dwl-suggest__add dss-card__btn" data-url="' + esc(p.u) + '" data-variant="' + p.v + '"' + (p.m ? ' data-multi="1"' : '') + (opts ? ' data-needs-options="1"' : '') + (p.a ? '' : ' disabled') + '>' + label + '</button></li>';
        }).join('') + '</ul>';
      box.hidden = false;
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('.dss-card__btn');
        if (btn) { e.preventDefault(); addToCart(btn); }
      });
      if (!zero) document.documentElement.classList.add('dwl-has-smart-results');
    });
  }

  function scan() {
    var fields = document.querySelectorAll('input[type="search"][name="q"], input[name="q"][type="text"]');
    for (var i = 0; i < fields.length; i++) wire(fields[i]);
    setPlaceholders();
  }
  /* Taalkeuze (app-switcher .tl-options) in vaste volgorde: EN, NL, DE, FR, ES */
  var LANG_ORDER = ['en', 'nl', 'de', 'fr', 'es'];
  function orderLanguages() {
    var lists = document.querySelectorAll('.tl-options');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      var items = Array.prototype.slice.call(ul.querySelectorAll(':scope > .tl-option[data-value]'));
      if (items.length < 2) continue;
      var sorted = items.slice().sort(function (a, b) {
        var ia = LANG_ORDER.indexOf(a.getAttribute('data-value')), ib = LANG_ORDER.indexOf(b.getAttribute('data-value'));
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      var same = sorted.every(function (el, k) { return el === items[k]; });
      if (!same) sorted.forEach(function (el) { ul.appendChild(el); });
    }
  }

  function boot() {
    scan();
    orderLanguages();
    searchPage();
    var tries = 0, iv = setInterval(function () { tries++; scan(); orderLanguages(); if (tries > 20) clearInterval(iv); }, 250);
    document.addEventListener('shopify:section:load', scan);
    // Index pas ophalen als iemand het zoekvak aanraakt (houdt de pagina snel)
    document.addEventListener('pointerover', function pre(e) {
      if (e.target.closest && e.target.closest('.search-dropdown, .dwl-searchbar, form[role="search"]')) { loadIndex(); document.removeEventListener('pointerover', pre); }
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
